import React, { useState, useEffect, useContext } from "react";
import { ModalDialog } from "./common/ModalDialog";
import { DiseaseGroupContext } from "../contexts/diseaseGroupContext";
import { XCircle } from "./common/IconsV2";
import { AccessibleFocusOutline } from "./common/AccessibleFocusOutline";

export const BrowserPopup = ({
	show,
	onClose,
	title,
	currentTheme,
	url,
	showCloseText,
	text,
}) => {
	const [theme, setTheme] = useState(currentTheme);

	const context = useContext(DiseaseGroupContext);

	const closeHandler = () => {
		onClose();
	};

	useEffect(() => {
		if (theme) {
		} else {
			setTheme(context.theme.primary());
		}
	}, [theme, context.theme]);

	return (
		<ModalDialog show={show} onClose={closeHandler}>
			<div
				className={`relative bg-white flex flex-col text-black w-full h-full max-h-panel-xl shadow-lg overflow-hidden transition-all transform rounded-lg`}
			>
				<div className="right-0.5 top-0.5 absolute items-center p-1 bg-white bg-opacity-80 rounded-lg border border-red-700">
					<AccessibleFocusOutline>
						<button onClick={closeHandler} className="flex items-center">
							{showCloseText && (
								<span className={"text-xs sm:text-sm mr-1.5 text-red-700"}>
									Close
								</span>
							)}
							<XCircle className={`w-4 sm:w-4 text-red-700`} />
						</button>
					</AccessibleFocusOutline>
				</div>

				<div className={"flex-grow overflow-y-auto"}>
					{url ? (
						<object title={title || ""} data={url} className="w-full h-full">
							Loading...
						</object>
					) : (
						<div className="m-2 text-center">
							<h6 className="text-2xl mb-8">Sorry</h6>
							<p className="mb-3">
								We're unable to display any 'Help' right now.
							</p>
							<p className="mb-3">Please try again later.</p>
						</div>
					)}
				</div>

				<div className={"absolute left-0 right-0 bottom-0"}></div>
			</div>
		</ModalDialog>
	);
};
